"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var prefixObjectKeys = function prefixObjectKeys(obj, prefix) {
  return Object.fromEntries(Object.keys(obj).map(function (key) {
    return ["".concat(prefix).concat(key), obj[key]];
  }));
};
var _default = prefixObjectKeys;
exports["default"] = _default;